// --- UPDATE PAGINATION: count, progress și next page ---

// 2a) Actualizează count/progress local, independent de răspuns
const comp = btn.closest('pagination-component');
const total = parseInt(comp?.getAttribute('data-total') || '0', 10);
const pageSize = parseInt(comp?.getAttribute('data-page-size') || String(newItems.length) || '0', 10);

// curent = curent + câte am adăugat efectiv
let current = parseInt(comp?.getAttribute('data-current') || '0', 10);
current += newItems.length;
comp.setAttribute('data-current', String(current));

// UI: textul "X afișate din Y rezultate"
const countEl = comp.querySelector('[data-count]');
if (countEl) {
  // poți păstra textul existent în română:
  countEl.textContent = `${current} afișate din ${total} rezultate`;
}

// UI: progres (folosește variabila CSS)
const progressEl = comp.querySelector('[data-progress]');
if (progressEl) {
  const percent = total ? (current / total) * 100 : 100;
  progressEl.style.setProperty('--gsc-pagination-progress', `${percent}%`);
}

// 2b) Calculează următorul URL (page++)
const curPageAttr = parseInt(btn.getAttribute('data-page') || '2', 10); // ex: 2, 3, 4...
const nextPage = curPageAttr + 1;

// helper mic: incrementează param. "page" într-un URL relativ
function bumpPageParam(u, p) {
  // creăm un URL absolut temporar doar ca să putem folosi URL API
  const tmp = new URL(u, window.location.origin);
  tmp.searchParams.set('page', String(p));
  // ne asigurăm că păstrăm &_ajax=1
  if (!tmp.searchParams.has('_ajax')) tmp.searchParams.set('_ajax', '1');
  return tmp.pathname + tmp.search;
}

// dacă am atins / depășit totalul, ascundem componenta
if (current >= total) {
  comp.remove();
} else {
  // setează noul data-url și page
  const newUrl = bumpPageParam(btn.getAttribute('data-url'), nextPage);
  btn.setAttribute('data-url', newUrl);
  btn.setAttribute('data-page', String(nextPage));
}
